export const routesData = [
  {
    route: '/casb/google',
    screen: '/applications',
    part: 'admin',
  },
  {
    route: '/casb/office365',
    screen: '/applications',
    part: 'admin',
  },
  {
    route: '/casb/atlassian',
    screen: '/applications',
    part: 'admin',
  },
  {
    route: '/casb/shopify',
    screen: '/applications',
    part: 'admin',
  },
  {
    route: '/casb/shopify-plus',
    screen: '/applications',
    part: 'admin',
  },
  {
    route: '/add/tenant',
    screen: '/dashboard',
    part: 'admin',
  },
  {
    route: '/settings',
    screen: '/dashboard',
    part: 'admin',
  },
  {
    route: '/dashboard',
    screen: '/dashboard',
    part: 'admin',
  },
  {
    route: '/manage-policy',
    screen: '/manage-policy',
    part: 'admin',
  },
  {
    route: '/configure/authentication-source',
    screen: '/configure/authentication-source',
    part: 'admin',
  },
  {
    route: '/add/proxy',
    screen: '/configure/proxy',
    part: 'admin',
  },
  {
    route: '/configure/proxy',
    screen: '/configure/proxy',
    part: 'admin',
  },
  {
    route: '/applications',
    screen: '/applications',
    part: 'admin',
  },
  {
    route: '/auditing-dashboard',
    screen: '/auditing-dashboard',
    part: 'audit',
  },
  {
    route: '/insights',
    screen: '/insights',
    part: 'audit',
  },
  {
    route: '/reports',
    screen: '/insights',
    part: 'audit',
  },
];

export const getScreenByRoute = (currentRoute: any) => {
  const routeData = routesData.find((route) => route.route === currentRoute);
  return routeData ? routeData.screen : '/applications';
};
